module.exports = __webpack_public_path__ + "img/swichDateIcon.d1052c75.svg";